import store from '@/store';
import { leaseType, repaymentMethodList } from '@/util/dictList.js';
export const option = {
  height: 'auto',
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchSpan: 5,
  searchMenuSpan: 4,
  border: true,
  index: true,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  selection: false,
  dialogClickModal: false,
  searchIcon: true,
  searchIndex: 7,
  searchLabelWidth: 100,
  column: [
    {
      label: '姓名',
      prop: 'name',
      type: 'input',
      search: true,
      display: false,
      searchOrder: 888,
    },
    {
      label: '所属代理商',
      prop: 'createDeptName',
      span: 24,
    },
    {
      label: '所属代理商',
      prop: 'createDepts',
      type: 'select',
      filterable: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 1000,
      hide: true,
      dicData: [],
      props: {
        label: 'title',
        value: 'id',
      },
    },
    // {
    //   label: '产品类型',
    //   prop: 'rentType',
    //   type: 'select',
    //   display: false,
    //   search: true,
    //   showColumn: false,
    //   hide: false,
    //   dicData: store.getters.porductTypes,
    //   searchOrder: 996,
    // },
    {
      label: '平台',
      prop: 'platformManagementId',
      type: 'select',
      display: false,
      search: true,
      searchMultiple: false,
      showColumn: false,
      hide: true,
      dicData: [],
      searchOrder: 722,
      props: {
        label: 'platformName',
        value: 'id',
      },
    },
    {
      label: '平台',
      prop: 'platformName',
      span: 24,
    },
    {
      label: '平台金额',
      prop: 'platformAmount',
      span: 24,
      display: false,
    },
    {
      label: '还款方式',
      prop: 'repaymentMethod',
      minWidth: 90,
      span: 24,
      type: 'select',
      display: false,
      dicData: repaymentMethodList,
    },
    {
      label: '平台期数',
      prop: 'repayment',
      span: 24,
      type: 'input',
      display: false,
      searchRules: [
        {
          pattern: /^(0?[1-9]|[12][0-9]|3[0-6])$/,
          message: '请输入1~36',
          trigger: ['blur', 'change'],
        },
      ],
      formatter: (val, value) => {
        return value ? value + '期' : '';
      },
    },
    {
      label: '平台利率',
      prop: 'platformRate',
      span: 24,
      minWidth: 90,
      display: false,
      formatter: (val, value) => {
        return value ? value + '%' : '';
      },
    },
    {
      label: '每月还款',
      prop: 'platformRepaymentAmount',
      span: 24,
      display: false,
    },
    // {
    //   label: '平台还款日期',
    //   prop: 'repaymentDate',
    //   type: 'daterange',
    //   valueFormat: 'yyyy-MM-dd',
    //   searchRange: true,
    //   display: false,
    //   search: true,
    //   searchOrder: 444,
    // },
    // {
    //   label: '客户还租日期',
    //   prop: 'currentLendingDate',
    //   type: 'daterange',
    //   searchRange: true,
    //   valueFormat: 'yyyy-MM-dd',
    //   display: false,
    //   search: true,
    //   searchOrder: 333,
    // },
    // {
    //   label: '平台还款日',
    //   prop: 'platformReturnDate',
    //   type: 'select',
    //   display: false,
    //   // search: true,
    //   hide: true,
    //   multiple: true,
    //   searchOrder: 222,
    //   dicData: (() => {
    //     let arr = [];
    //     for (let i = 1; i < 32; i++) {
    //       arr.push({
    //         label: i + '日',
    //         value: i,
    //       });
    //     }
    //     return arr;
    //   })(),
    // },
    {
      label: '平台起租日',
      prop: 'platformRepaymentDate',
    },
    {
      label: '还租状态',
      prop: 'userRepaymentStatus',
    },
    {
      label: '代偿状态',
      prop: 'compensationStatus',
    },
    {
      label: '结清状态',
      prop: 'tenantAttribute',
    },
    {
      label: '起租日',
      prop: 'commencementDate',
      searchRange: true,
      type: 'daterange',
      valueFormat: 'yyyy-MM-dd',
      search: true,
      searchOrder: 777,
    },
    {
      label: '租赁金额',
      prop: 'lendingAmount',
      span: 24,
      display: false,
      searchOrder: 1000,
    },
    {
      label: '租期',
      prop: 'tenancy',
      type: 'select',
      display: false,
      showColumn: false,
      dicData: leaseType,
    },
    {
      label: '租率',
      prop: 'lendingRate',
      span: 24,
      display: false,
      searchOrder: 1000,
      formatter: (val, value) => {
        return value ? value + '%' : '';
      },
    },
    {
      label: '每期租金',
      prop: 'lendingAmountPer',
      span: 24,
      display: false,
      searchOrder: 1000,
    },
    {
      label: '客户类型',
      prop: 'customerType',
      dicData: [
        { label: '直管', value: 1 },
        { label: '代管', value: 2 },
      ],
    },
    {
      label: '车牌号',
      prop: 'carFirstNumber',
      search: true,
      searchOrder: 836,
    },
    {
      label: '进件编号',
      prop: 'businessCode',
      type: 'input',
      display: false,
      search: true,
      searchOrder: 111,
    },
  ],
};

//根据角色权限来展示
export const jurisdictionDifferentiate = {
  finance: [
    {
      title: '姓名',
      value: 'name',
      order: 1,
    },
    {
      title: '所属代理商',
      value: 'createDeptName',
      order: 2,
    },
    {
      title: '产品类型',
      value: 'rentType',
      order: 3,
    },
    {
      title: '租期',
      value: 'tenancy',
      order: 4,
    },
    {
      title: '平台',
      value: 'platformName',
      order: 5,
    },
    {
      title: '平台金额',
      value: 'platformAmount',
      order: 6,
    },
    {
      title: '平台利率',
      value: 'platformRate',
      order: 7,
    },
    {
      title: '平台期数',
      value: 'repayment',
      order: 8,
    },
    {
      title: '还款方式',
      value: 'repaymentMethod',
      order: 9,
    },
    {
      title: '还款日期',
      value: 'repaymentDate',
      order: 10,
    },
    {
      title: '每期还款金额',
      value: 'platformRepaymentAmount',
      order: 11,
    },
  ],
};
